import Vue from "vue"
import Router from "vue-router"

import Home from "./views/Home.vue"
import UserRoot from "./views/UserRoot.vue"
import Menu from "./views/Menu.vue"
import Checkout from "./views/Checkout.vue"
import BusinessHome from "./views/BusinessHome.vue"
import Success from "./views/Success.vue"
import Embed from "./views/Embed.vue"
import ToS from "./views/ToS.vue"
import Privacy from "./views/Privacy.vue"
import Location from "./views/Location.vue"
import OrderVerification from "./views/OrderVerification.vue"
import UserAccountSettings from "./views/UserAccountSettings.vue"
import UserOrders from "./views/UserOrders.vue"
import UpcomingEvents from "./views/UpcomingEvents.vue"
import UserRewards from "./views/UserRewards.vue"

Vue.use(Router)

const router = new Router({
	mode: "history",
	base: __dirname,
	routes: [
		{
			path: "/",
			name: "Location",
			component: Location
		},
		{
			path: "/user",
			component: UserRoot,
			meta: { user: true },
			children: [
				{
					name: "account",
					path: "account",
					component: UserAccountSettings,
					meta: {
						title: "Account"
					}
				},
				{
					name: "orders",
					path: "orders",
					component: UserOrders,
					meta: {
						title: "Orders"
					}
				},
				{
					name: "rewards",
					path: "rewards",
					component: UserRewards,
					meta: {
						title: "Rewards"
					}
				}
			]
		},
		{
			path: "/:slug?",
			component: Home,
			children: [
				{
					name: "home",
					path: "/",
					component: BusinessHome,
					meta: {
						startsSession: true
					}
				},
				{
					name: "events",
					path: "events",
					component: UpcomingEvents,
					meta: {
						startsSession: true,
						title: "Events"
					}
				},
				{
					name: "menu_event",
					path: "menu/event/:eventId",
					component: Menu,
					meta: {
						startsSession: true,
						isEvent: true,
						isMenu: true
					}
				},
				{
					name: "menu_preview",
					path: "menu/preview/:preview_menu?",
					component: Menu,
					meta: {
						preview: true,
						startsSession: true,
						isMenu: true
					}
				},
				{
					name: "menu_token",
					path: "menu/token/:token",
					component: Menu,
					meta: {
						startsSession: true,
						isMenu: true
					}
				},
				// This route is no longer supported and has a redirect rule to prevent user interaction with the page
				{
					name: "menu_2go",
					path: "menu/2go",
					redirect: "/"
				},
				/*****/
				{
					name: "menu",
					path: "menu/:table?",
					component: Menu,
					meta: {
						startsSession: true,
						isMenu: true
					}
				},
				{
					name: "checkout_event",
					path: "checkout/event/:eventId",
					component: Checkout,
					meta: {
						isEvent: true,
						isCheckout: true
					}
				},
				{
					name: "checkout",
					path: "checkout/:order_session_id?",
					component: Checkout,
					meta: {
						isCheckout: true
					}
				},
				{
					name: "track",
					path: "track/:order_id?",
					component: Success
				},
				{
					name: "order_verification",
					path: "verify/:order_id?",
					component: OrderVerification
				},
				{
					name: "embed",
					path: "embed",
					component: Embed
				},
				{
					path: "terms_of_use",
					component: ToS
				},
				{
					path: "privacy",
					component: Privacy
				}
			]
		}
	]
})

router.beforeEach((to, from, next) => {
    if (to.name == "embed") {
      if (to.query.theme && to.query.theme == "dark") {
          document.body.classList.add("dark-theme")
      } else {
        document.body.classList.remove("dark-theme")
      }
    } else {
        document.body.classList.remove("dark-theme")
    }
    next()
})

export default router